import React, { useState, useContext } from "react";
import { Button } from "../../misc/button/Button";
import axios from "axios";
import { BACKEND_URL } from "../../../config/config";
import { NotificationContext } from "../../context/NotificationWrapper";
import { Spin } from "antd";

function TestPaymentPage() {
  const [loading, setLoading] = useState(false);
  const { openNotification } = useContext(NotificationContext);

  const handleTestPayment = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/test-payment/init`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { redirectUrl, merchantReference } = response.data;

      // Stocker la référence en sessionStorage pour la page de retour
      sessionStorage.setItem("testPaymentRef", merchantReference);

      console.log("Test payment init:", response.data);

      // Rediriger vers Worldline
      window.location.href = redirectUrl;
    } catch (error) {
      console.error("Erreur test payment:", error);
      setLoading(false);

      openNotification(
        "Erreur",
        error.response?.data?.error || "Impossible d'initialiser le paiement test",
        "error"
      );
    }
  };

  return (
    <div className="block-right">
      <div className="info-declaration">
        <h4 style={{ textTransform: "uppercase" }}>
          Test de Paiement Worldline
        </h4>

        <div style={{ marginTop: "30px", marginBottom: "20px" }}>
          <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
            <strong>Attention :</strong> Cette fonctionnalité est réservée à l'admin (userId = 1)
            pour tester l'intégration de paiement Worldline.
          </p>

          <p style={{ fontSize: "16px", lineHeight: "1.6", marginTop: "15px" }}>
            En cliquant sur le bouton ci-dessous, vous allez :
          </p>

          <ul style={{ fontSize: "16px", lineHeight: "1.8", marginLeft: "20px" }}>
            <li>Initier un paiement de test de <strong>1€</strong></li>
            <li>Être redirigé vers la page de paiement Worldline</li>
            <li>Pouvoir tester une transaction avec une carte de test</li>
            <li>Revenir sur une page de résultat pour voir le statut</li>
          </ul>

          <p style={{ fontSize: "16px", lineHeight: "1.6", marginTop: "15px", color: "#666" }}>
            <em>Note : Aucune Order, Declaration ou Bill ne sera créée.
            Toutes les actions sont loguées dans var/log/test_payment.log</em>
          </p>
        </div>

        <div style={{ marginTop: "30px", textAlign: "center" }}>
          {loading ? (
            <Spin size="large" tip="Redirection vers Worldline..." />
          ) : (
            <Button
              onClick={handleTestPayment}
              style={{
                padding: "12px 40px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Tester le paiement Worldline (1€)
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TestPaymentPage;
